module.exports = __webpack_public_path__ + "img/pc_safe5000_icon.62deb531.png";